import React from 'react';
import './_house-list.scss';
import HouseModel from "../house-model/house-model";
import VStore from "../../../../store";

export default function HouseList() {
    const {houseData, priceRange, sizeRange, roomVariables} = VStore();

    const filteredHouseData = houseData.filter(item => {
        return item.price >= priceRange.min && (priceRange.max ? item.price <= priceRange.max : true)
            && item.size >= sizeRange.min && (sizeRange.max ? item.size <= sizeRange.max : true)
            && (roomVariables.bedroom ? item.bedroom === roomVariables.bedroom : true)
            && (roomVariables.bathroom ? item.bathroom === roomVariables.bathroom : true)
            && (roomVariables.garage ? item.garage >= roomVariables.bathroom : true);
    });

    return <div className='house-list'>
        {
            filteredHouseData.map((item, index) =>
                <HouseModel key={item.name + '_' + index}
                            imgSrc={item.imgSrc}
                            name={item.name}
                />
            )
        }
    </div>;
}
